<div class="office-detail d-flex flex-column flex-grow-1 justify-content-end">
  <p class="fw-normal m-0 name">{{ office.name }}</p>
  <p class="fw-light">
    {{ office.address.fullAddress }}<br />
    {{ office.address.city }}, {{ office.address.state }} {{ office.address.zip }}
  </p>
</div>
